<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      style="width: 400px; min-height: 400px;"
    >
      <q-form
        ref="formRef"
      >
        <q-card-section class="row items-center q-mx-xs">
          <div class="text-h6">
            Bulk Voucher Generation
          </div>
          <q-space />
          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </q-card-section>
        <q-card-section>
          <div class="row q-col-gutter-sm">
            <q-input
              class="col-12 q-mb-md"
              autogrow
              readonly
            >
              <template #default>
                <div class="col-12 row text-black text-center q-pa-sm">
                  Generate vouchers to distribute without sale.
                  <br>Generated vouchers will be redeemable immediately.
                </div>
              </template>
            </q-input>
            <q-select
              v-model="selectedVoucherType"
              class="col-12"
              label="Voucher Type"
              :options="voucherTypes.data"
              option-label="name"
              :rules="[val => val !== null || 'A Voucher Type selection is required']"
              bottom-slots
            />
            <q-input
              v-model.number="numberOfVouchers"
              type="number"
              class="col-12"
              label="Number Of Vouchers To Generate"
              :rules="[val => (!!val && val >= 1 && val <= 10000) || 'Number of vouchers must be between 1 and 10000']"
            />
            <q-toggle
              v-model="generateCardNumbers"
              class="col-6 q-pb-md"
              label="Generate Cards"
            />
            <q-input
              v-if="generateCardNumbers && (selectedVoucherType && selectedVoucherType.barcodeOptions.card_uid_increment_length > 0)"
              v-model.number="startCardNumber"
              class="col-6"
              label="Start Card Number"
              step="1"
              min="0"
              :rules="[val => val !== null && val > -1 || 'Card number must be 0 or greater']"
            >
              <q-tooltip>
                Card Iterator to start generating from
              </q-tooltip>
            </q-input>
            <q-input
              v-if="generateCardNumbers && (selectedVoucherType && selectedVoucherType.barcodeOptions.card_uid_increment_length > 0)"
              v-model="voucherTypeCardPattern"
              class="col-12"
              label="Card Pattern"
              disable
              readonly
              :rules="[_ => selectedVoucherType && (!selectedVoucherType.barcodeOptions.card_uid_length || ((selectedVoucherType.barcodeOptions.card_uid_prefix.length + numberOfVouchers.toString().length) <= selectedVoucherType.barcodeOptions.card_uid_length)) || 'Card pattern length cannot exceed maximum voucher type card length']"
            />
          </div>
        </q-card-section>
        <q-card-actions class="row justify-end q-ma-sm">
          <q-btn
            label="Generate And Download"
            color="primary"
            @click="downloadExport()"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>

import { Notify } from 'quasar'
import { serverUri } from 'src/config'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export default {
  name: 'VoucherBulkActivationDialog',
  mixins: [FormValidationMixin],
  configuration: ['currentCircuit', 'voucherTypes'],
  data () {
    return {
      selectedVoucherType: null,
      numberOfVouchers: 1000,
      generateCardNumbers: true,
      startCardNumber: 0,
      shown: false
    }
  },
  computed: {
    voucherTypeCardPattern () {
      if (!this.selectedVoucherType) return null

      let cardPrefix = `${this.selectedVoucherType.barcodeOptions.card_uid_prefix}`

      if (this.selectedVoucherType.barcodeOptions.card_uid_increment_length > 0) {
        cardPrefix += `${this.startCardNumber.toString().padStart(this.selectedVoucherType.barcodeOptions.card_uid_increment_length, '0')}`
      }

      return cardPrefix.padEnd(this.selectedVoucherType.barcodeOptions.card_uid_length, '.')
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    buildUri () {
      const endpoint = `${serverUri}/generate_vouchers`

      const parameters = `?number_of_vouchers=${this.numberOfVouchers}&voucher_type_id=${this.selectedVoucherType.id}&generate_card_numbers=${this.generateCardNumbers}&generate_blank_cards=false&start_card_number=${this.startCardNumber}`

      return endpoint + parameters
    },
    downloadExport () {
      this.validateForm(() => {
        window.location.href = this.buildUri()

        Notify.create({
          message: 'Vouchers are being generated, please wait',
          position: 'top',
          type: 'positive'
        })
        this.shown = false
      })
    }
  }
}

</script>
